import {
  buildMessagesForSchoolCountsListPath,
  buildMessagesListPath,
} from '../../generated/schooly-api-v1/api-paths';

export const getMessagePath = buildMessagesListPath;
export const messagesForSchoolCountsPath = buildMessagesForSchoolCountsListPath;
